module.exports = __webpack_public_path__ + "img/close_red2.6791a224.svg";